import {Routes} from '@angular/router';
import {UserType} from '@infrastructure/generic-auth/user-type.enum';
import {authRedirect} from './core/auth-redirect';
import {userNotAuthenticatedGuard} from './core/guards/not-authenticated.guard';
import {PatientTimelineInformationComponent} from './features/patient-timeline-information/patient-timeline-information.component';
import {PrivacyPolicyComponent} from './features/privacy-policy/privacy-policy.component';
import {PublicTimelineSharingComponent} from './features/public-timeline-sharing/public-timeline-sharing.component';
import {TermsAndConditionsComponent} from './features/terms-conditions/terms-conditions.component';
import {LayoutComponent} from './shared/layout/layout.component';

export const routes: Routes =
[
    {
        path: '',
        pathMatch: 'full',
        redirectTo: authRedirect
    },
    {
        path: 'patient-timeline-information',
        component: PatientTimelineInformationComponent
    },
    {
        path: 'public-timeline-sharing',
        component: PublicTimelineSharingComponent
    },
    {
        path: 'privacy-policy',
        component: PrivacyPolicyComponent
    },
    {
        path: 'terms-&-conditions',
        component: TermsAndConditionsComponent
    },
    {
        path: 'owner',
        loadChildren: () => import('./core/routes/auth/owner.routes').then((ownerRoutes) => ownerRoutes),
        canActivateChild: [userNotAuthenticatedGuard],
        data: {
            type: UserType.OWNER
        }
    },
    {
        path: 'admin',
        loadChildren: () => import('./core/routes/auth/admin.routes').then((adminRoutes) => adminRoutes)
    },
    {
        path: 'clinician',
        loadChildren: () => import('./core/routes/auth/clinician.routes').then((clinicianRoutes) => clinicianRoutes)
    },
    {
        path: 'dashboard',
        component: LayoutComponent,
        loadChildren: () => import('./core/routes/protected/protected.routes').then((protectedRoutes) => protectedRoutes)
    },
    {
        path: '**',
        redirectTo: authRedirect
    }
];
